import { all, takeEvery, fork, put, select, call } from 'redux-saga/effects'
import actions from './actions'

// api
import {
    getListMedias,
    createMedia,
    deleteMedia,
    updateMediaById,
    uploadMediaFile,
    getListMediaQueryById,
} from '../../services/apis/QBMediaAPIServices'
import { message } from 'antd'

function* saga_getMediaByid(action) {
    try {
        const { lst } = action.payload
        const request = yield call(getListMediaQueryById, lst)
        if (request.error.code === 200) {
            yield put(actions.action.updateCurrentMedia(request.data[0]))
        } else {
            yield put(actions.action.updateCurrentMedia({}))
        }
    } catch (ex) {
        console.error('get media by error : ', ex.message)
    }
}

function* saga_getListMediaQueryById(action) {
    try {
        const { lst } = action.payload
        const request = yield call(getListMediaQueryById, lst)
        if (request.error.code === 200) {
            yield put(actions.action.getListMediaQueryByIdDone(request.data))
        } else {
            yield put(actions.action.getListMediaQueryByIdDone([]))
        }
    } catch (ex) {
        console.error('Load list media error : ', ex.message)
    }
}

function* saga_LoadListMedia(action) {
    try {
        const { params } = action.payload

        let page_number = yield select(state => state.qbmedia.pageIndex)
        let page_size = yield select(state => state.qbmedia.pageSize)
        let status = yield select(state => state.qbmedia._status)
        let textSearch = yield select(state => state.qbmedia.lastTextSearch)
        let begin_time = yield select(state => state.qbmedia.begin_time)
        let end_time = yield select(state => state.qbmedia.end_time)
        let type_search = yield select(state => state.qbmedia.type_search)
        if (params.page_number) page_number = params.page_number
        if (params.page_size) page_size = params.page_size
        if (params.status != null) status = params.status

        const response = yield call(
            getListMedias,
            page_number,
            page_size,
            status,
            textSearch,
            begin_time,
            end_time,
            type_search
        )

        if (response.error.code === 200) {
            let medias = response.data
            let total = response.total

            if (medias.length > page_size) medias = medias.slice(0, page_size)

            yield put(actions.action.loadListMediasSuccess(medias))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total,
                    pageIndex: page_number,
                })
            )
        } else {
            console.error(
                'Get list medias API server error ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('Load list media error : ', ex.message)
    }
}

function* saga_SaveCurrentMedia() {
    try {
        let currentMedia = yield select(state => state.qbmedia.currentMedia)
        let ListCurrentEvent = yield select(state => state.scrumBoard.ListCurrentEvent)
        let ListCurrentObject = yield select(state => state.scrumBoard.ListCurrentObject)
        let event_id = []
        let obj_id = []
        ListCurrentObject.map(vl => {
            obj_id.push(vl.object_id)
        })
        ListCurrentEvent.map(vl => {
            event_id.push(vl.event_id)
        })
        const file = yield select(state => state.qbmedia.file)
        currentMedia = {
            ...currentMedia,
            ...{
                ext_data: { obj_ids: JSON.stringify(obj_id), event_ids: JSON.stringify(event_id) }
            },
        }
        let dataFile = []
        // upload file
        try {
            if (file != null && file.length > 0) {
                for (let i = 0; i < file.length; i++) {

                    const responseUploadFile = yield call(uploadMediaFile, file[i])
                    const file_url = responseUploadFile.uploaded_files[0]
                    console.log('responseUploadFile', responseUploadFile)
                    currentMedia = {
                        ...currentMedia,
                        ...{
                            url: file_url,
                        },
                    }
                    console.log('file data', file[i])
                    let dataCreate = {
                        url: file_url,
                        hashtag: currentMedia.hashtag,
                        type: 0,
                        name: file[i].name,
                        media_id: 0

                    }

                    dataFile = dataFile.concat(dataCreate)
                }

            }
        } catch (ex) {
            console.error('Upload file error : ', ex.message)
        }
        console.log('data file', dataFile)
        // put to server
        let response = ''
        if (currentMedia.media_id === 0) {
            // create media
            for (let i = 0; i < dataFile.length; i++) {
                response = yield call(createMedia, dataFile[i])
                console.log('respone create', response)
            }

        } else {
            //update media
            response = yield call(
                updateMediaById,
                currentMedia.media_id,
                currentMedia
            )
        }

        if (response.error.code === 200) {
            if (currentMedia.media_id === 0)
                message.success('Thêm tài liệu thành công')
            else message.success('Sửa tài liệu thành công')

            yield put(actions.action.loadListMedias({}))
        } else {
            console.log(
                'Save current media call API error : ',
                response.error.message
            )
        }
    } catch (ex) {
        console.error('Save current media error : ', ex.message)
    }
}

function* saga_DeleteMedia(action) {
    try {
        const { mediaId } = action.payload
        const response = yield call(deleteMedia, mediaId)

        if (response.error.code === 200) {
            message.success('Xoá tài liệu thành công')

            yield put(actions.action.loadListMedias({}))
        }
    } catch (ex) {
        console.error('Delete media error : ', ex.message)
    }
}

function* saga_ChangePageSize(action) {
    try {
        const { pageSize } = action.payload

        yield put(actions.action.loadListMedias({ page_size: pageSize }))
    } catch (ex) {
        console.log('Change page media size error : ', ex.message)
    }
}

function* saga_ChangeCurrentPage(action) {
    try {
        const { pageIndex } = action.payload

        yield put(actions.action.loadListMedias({ page_number: pageIndex }))
    } catch (ex) {
        console.log('Change current media page error : ', ex.message)
    }
}

function* saga_SearchMedia(action) {
    try {
        let page_number = 1
        let page_size = yield select(state => state.qbmedia.pageSize)
        let status = yield select(state => state.qbmedia._status)
        let textSearch = yield select(state => state.qbmedia.textSearch)
        const { begin_time, end_time, type_search } = action.payload

        const response = yield call(
            getListMedias,
            page_number,
            page_size,
            status,
            (textSearch),
            begin_time, end_time, type_search
        )

        if (response.error.code === 200) {
            let medias = response.data
            let total = response.total

            if (medias.length > page_size) medias = medias.slice(0, page_size)

            yield put(actions.action.loadListMediasSuccess(medias))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total,
                    pageIndex: 1,
                })
            )
        } else {
            yield put(actions.action.loadListMediasSuccess([]))
            yield put(
                actions.action.updateState({
                    _status: status,
                    total: 0,
                    pageIndex: 1,
                })
            )
        }
    } catch (ex) {
        console.log('search media error : ', ex.message)
    }
}

function* listen() {
    yield takeEvery(actions.type.LOAD_LIST_MEDIA, saga_LoadListMedia)
    yield takeEvery(actions.type.SAVE_CURRENT_MEDIA, saga_SaveCurrentMedia)
    yield takeEvery(actions.type.DELETE_MEDIA, saga_DeleteMedia)
    yield takeEvery(actions.type.CHANGE_PAGE_SIZE, saga_ChangePageSize)
    yield takeEvery(actions.type.CHANGE_CURRENT_PAGE, saga_ChangeCurrentPage)
    yield takeEvery(
        actions.type.GET_LIST_MEDIA_QUERY_BY_ID,
        saga_getListMediaQueryById
    )
    yield takeEvery(actions.type.SEARCH_MEDIA, saga_SearchMedia)
    yield takeEvery(actions.type.SEARCH_MEDIA, saga_getMediaByid)
}

export default function* qbmediaSaga() {
    yield all([fork(listen)])
}
